import React from 'react';
import { Modal } from 'react-bootstrap';
import CloseButton from '../CloseButton';
import { connect, useDispatch } from 'react-redux';
import { s3Link } from '../../utils/constants';
import { setStash } from '../../../redux/actions/stash';

const ImageModal = ({
    showImageModal,
    containerClass,
    imageModalSource,
    stash
}) => {
    const dispatch = useDispatch();

    const handleImageModal = () => {
        const payload = {
            showImageModal: false,
            imageModalSource: '',
            containerClass: ''
        };

        dispatch(setStash({
            ...stash,
            ...payload
        }));
    };


    return <Modal
        show={showImageModal}
        onHide={handleImageModal}
        className="videoCont-modal"
        centered
        size="lg"
        animation={false}
    >
        <Modal.Body>
            <div className={containerClass}>
                <CloseButton
                    className="close"
                    onClick={handleImageModal}
                    style={{ position: 'absolute', top: '12px', right: '12px' }}
                />
                <div className="embed-responsive chat-vid-cont img-vid-cont embed-responsive-4by3">
                    <img
                        src={`${s3Link}/${imageModalSource}`}
                        nosave="true"
                        onContextMenu={(e) => e.preventDefault()}
                    />
                </div>
            </div>
        </Modal.Body>
    </Modal>;
};

const mapStateToProps = state => {
    return {
        stash: state.stash,
        showImageModal: state.stash.showImageModal,
        containerClass: state.stash.containerClass,
        imageModalSource: state.stash.imageModalSource,
    };
};

export default connect(mapStateToProps)(React.memo(ImageModal));
